/**
 * Fragment de routes du paquet v8c-p01-securite-connexion (vague V8c, règle R2 du découpage V4–V11 : un fragment par
 * paquet). Composants chargés à la demande (règle de chargement du registre).
 *  - Remplacement du socle (`couvre: route:/org/securite` du YAML) : `/org/securite` → organisation-securite-connexion ;
 *  - dialogue en écran plein (route neuve) : `/org/securite/verifier-domaine` (`?domaine=<id>` pour une reprise).
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const OrganisationSecuriteConnexion = lazy(() => import('../ecrans/v8c/securite/OrganisationSecuriteConnexion'))
const DialogueVerifierDomaine = lazy(() => import('../ecrans/v8c/securite/DialogueVerifierDomaine'))

function ecran(Composant: ComponentType<{ session: Session }>) {
  return ({ session, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v8c-securite',
  routes: [
    { chemin: '/org/securite', element: ecran(OrganisationSecuriteConnexion), remplace: true },
    { chemin: '/org/securite/verifier-domaine', element: ecran(DialogueVerifierDomaine) },
  ],
}
